
export default () => {

  const teamGliderBlock = document.querySelector('.content-team__list')
  if (!teamGliderBlock) {
    return
  }

  let teamGlider = undefined;
  let isMobile = false
  if( window.innerWidth < 992 ) {
    isMobile = true
  }


  if( isMobile ) {

    document.addEventListener('glider-loaded', hideFFScrollBars);
    document.addEventListener('glider-refresh', hideFFScrollBars);
    function hideFFScrollBars(e){
      var scrollbarHeight = 17; // Currently 17, may change with updates
      //if(/firefox/i.test(navigator.userAgent)){
        e.target.parentNode.style.height = (e.target.offsetHeight - scrollbarHeight) + 'px'
      //}
    }

    if( teamGlider == undefined ) {
      teamGlider = new Glider(teamGliderBlock, {
        slidesToShow: 1,
        slidesToScroll: 1,
        scrollLock: true,
        draggable: true,
        arrows: {
          prev: '.content-team__glider-prev',
          next: '.content-team__glider-next'
        },
        responsive: [
          {
            // screens greater than >= 320px
            breakpoint: 320,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              duration: 0.25
            }
          },{
            // screens greater than >= 576px
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              duration: 0.25
            }
          }
        ]
      })

      teamGlider.updateControls()
      teamGlider.refresh()
    }

  }
  else {
    if( teamGlider != undefined ) {
      teamGlider.destroy()
      teamGlider = undefined
    }
  }

}

